import styled from 'styled-components'

export const ValueContainer = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 5%;
  background-color: rgb(255, 255, 255);
  text-align: center;
`

export const Title = styled.h2`
  font-family: Sora;
  font-size: 3.5rem;
  color: #fa8c16;
  margin-bottom: 40px;
  @media (max-width: 768px) {
    font-size: 2rem;
  }
`

export const FlexContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
`

export const CardsContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  gap: 8px;
  width: 60%;
  @media (max-width: 720px) {
    width: 100%;
  }
`

export const CardLeft = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;

  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
  }
`

export const CardRight = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row-reverse;
  align-items: center;
  padding: 20px;

  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
  }
`

export const Image = styled.img`
  max-width: 250px;
  height: auto;
  @media (max-width: 500px) {
    width: 130px;
    margin-right: 0;
    margin-bottom: 20px;
  }
`

export const Description = styled.div`
  width: 50%;
  text-align: start;
  h3 {
    font-family: Sora;
    font-size: 2rem;
    color: #000000;
    margin-bottom: 10px;
  }

  p {
    font-family: Sora;
    font-size: 1.3rem;
    color: #000000;
  }
  @media (max-width: 500px) {
    width: 100%;
    text-align: center;
    h3 {
      font-size: 1.5rem;
    }

    p {
      font-size: 1rem;
    }
  }
`
